export default {
  apps: state => state.apps,
};
